import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import { ref, onMounted, watch, computed } from 'vue';
import MetaPixel from './utils/MetaPixel.vue';
import XPixel from './utils/XPixel.vue';
import GoogleAds from './utils/GoogleAds.vue';
import ConsentBanner from './views/ConsentBanner.vue'
import { useRoute } from 'vue-router';

interface ConsentChoice {
  action: 'accept' | 'decline';
  timestamp: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const pixelId = ref<string | null>(null);
const xAdsId = ref(null);
const googleAdsId = ref(null);
const googleAdsLabel = ref(null);
const googleAdsRef = ref(null);

const privacyPolicyUrl = ref<string | null>(null);

const hasAnyTracking = computed(() => {
  return !!(pixelId.value || xAdsId.value || googleAdsId.value);
});

const handleConsentGiven = (choice: ConsentChoice) => {
  // Notify all tracking components about consent change
  window.postMessage(JSON.stringify({
    type: 'CONSENT_UPDATED',
    payload: choice
  }), '*');
};


watch(
  () => route.params.productId,
  async (newProductId) => {
    if (newProductId) {
      const newCompanyId = route.params.companyId;  
      const response = await fetch(process.env.VUE_APP_API_URL + `/companies/${newCompanyId}/products/${newProductId}?view=content`);
      const data = await response.json();
      // privacyPolicyUrl.value = "https://getre.al/privacy-policy";
      if(data.isMetaPixel) {
        pixelId.value = data.metaPixelId;
      }
      if(data.isXPixel) {
        xAdsId.value = data.xPixelId;
      }
      if(data.isGoogleAds) {
        googleAdsId.value = data.googleAdsId;
      }
       if(data.privacyLink) {
        privacyPolicyUrl.value = data.privacyLink;
      }
    }
  }
);

// router.beforeEach((to) => {
//   if (to.path === "/") {
//     window.location.replace("http://getre.al");
//   }
// });

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (pixelId.value)
      ? (_openBlock(), _createBlock(MetaPixel, {
          key: 0,
          "pixel-id": pixelId.value
        }, null, 8, ["pixel-id"]))
      : _createCommentVNode("", true),
    (xAdsId.value)
      ? (_openBlock(), _createBlock(XPixel, {
          key: 1,
          "x-pixel-id": xAdsId.value
        }, null, 8, ["x-pixel-id"]))
      : _createCommentVNode("", true),
    (googleAdsId.value)
      ? (_openBlock(), _createBlock(GoogleAds, {
          key: 2,
          ref_key: "googleAdsRef",
          ref: googleAdsRef,
          "conversion-id": googleAdsId.value
        }, null, 8, ["conversion-id"]))
      : _createCommentVNode("", true),
    (hasAnyTracking.value)
      ? (_openBlock(), _createBlock(ConsentBanner, {
          key: 3,
          onConsentGiven: handleConsentGiven,
          "privacy-policy-url": (privacyPolicyUrl.value as string)
        }, null, 8, ["privacy-policy-url"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}
}

})